import React from 'react';
import { useTranslation } from 'react-i18next';
import { getOurStoryData } from './OurStoryData';
import './OurStory.css';

const OurStory = () => {
  const { t } = useTranslation();
  const data = getOurStoryData();

  return (
    <div className="our-story-page">
      {/* 1. Hero Banner */}
      <section className="story-hero-banner" style={{ backgroundImage: `url(${data.banner})` }}>
        <div className="hero-overlay"></div>
        <div className="hero-content">
          <h1 className="hero-title">{t('ourStory.heroTitle')}</h1>
          <p className="hero-subtitle">{t('ourStory.heroSubtitle')}</p>
        </div>
      </section>

      {/* 2. Our Promise */}
      <section className="story-section our-promise">
        <div className="container layout-2-cols">
          <div className="col-text">
            <h2>{data.promise.title}</h2>
            {data.promise.description.split('\n\n').map((para, idx) => (
              <p key={idx}>{para}</p>
            ))}
          </div>
          <div className="col-image">
            <img src={data.promise.image} alt={data.promise.title} />
          </div>
        </div>
      </section>

      {/* 3. Our Values */}
      <section className="story-section our-values">
        <div className="container layout-2-cols">
          <div className="col-image">
            <img src={data.values.image} alt={data.values.title} />
          </div>
          <div className="col-text">
            <h2>{data.values.title}</h2>
            {data.values.description.split('\n\n').map((para, idx) => (
              <p key={idx}>{para}</p>
            ))}
          </div>
        </div>
      </section>

      {/* Founder Section (Mr. Jeffrey Goldman) */}
      <section className="story-section founder-section">
        <h2 className="partners-title">{t('ourStory.executiveTeam')}</h2>
        <div className="container layout-2-cols">
          <div className="col-text">
            <h2>{data.founder.name}</h2>
            <p className="founder-hero-role">{data.founder.role}</p>
            {data.founder.description.split('\n\n').map((para, idx) => (
              <p key={idx} className="founder-hero-desc">{para}</p>
            ))}
          </div>
          <div className="col-image">
            <img src={data.founder.image} alt={data.founder.name} className="founder-hero-img" />
          </div>
        </div>
      </section>

      {/* 4. Partners */}
      <section className="story-section partners-section">
        <div className="container">
          <div className="partners-grid">
            {data.partners.map((partner, index) => (
              <div className="partner-card" key={index}>
                <div className="partner-avatar-wrapper">
                  <img src={partner.image} alt={partner.name} className="partner-avatar-img" />
                </div>
                <h3 className="partner-name">{partner.name}</h3>
                <p className="partner-role">{partner.role}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* 5. Footer Image */}
      <section className="story-footer-banner">
        <img
          src={data.footerImage}
          alt="AuraGlow Footer Banner"
          className="footer-banner-img"
        />
      </section>
    </div>
  );
};

export default OurStory;
